import { useMemo } from "react";
import format from "date-fns/format";

import {
  PaymentSummary as PaymentSummaryView,
  PaymentSummaryPricing,
} from "@covertree/ui";

interface Props {
  policyStartDate: string;
  pricing: PaymentSummaryPricing;
}

export function PaymentSummary({ policyStartDate, pricing }: Props) {
  const formattedStartDate = useMemo(
    () => format(new Date(`${policyStartDate} 00:00:00`), "MMMM do, yyyy"),
    [policyStartDate]
  );

  return (
    <PaymentSummaryView
      formattedStartDate={formattedStartDate}
      pricing={pricing}
    />
  );
}
